import { render, staticRenderFns } from "./LinkWithApisOrders.vue?vue&type=template&id=0e13a0f6&scoped=true&"
import script from "./LinkWithApisOrders.vue?vue&type=script&lang=js&"
export * from "./LinkWithApisOrders.vue?vue&type=script&lang=js&"
import style0 from "./LinkWithApisOrders.vue?vue&type=style&index=0&id=0e13a0f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e13a0f6",
  null
  
)

export default component.exports